export default {
    warnings: {
        straightRow: 'Letras que vêm em sequência no teclado são fáceis de adivinhar.',
        keyPattern: 'Padrões de teclado curtos são fáceis de adivinhar.',
        simpleRepeat: 'Caracteres repetidos, como "aaa" são fáceis de adivinhar.',
        extendedRepeat: 'Padrões de caracteres repetidos, como "abcabcabc" são fáceis de adivinhar.',
        sequences: 'Sequências comuns de caracteres, como "abc" são fáceis de adivinhar.',
        recentYears: 'Anos recentes são fáceis de adivinhar.',
        dates: 'Datas são fáceis de adivinhar.',
        topTen: 'Esta é uma senha muito usada.',
        topHundred: 'Esta é uma senha usada frequentemente.',
        common: 'Esta é uma senha comumente usada.',
        similarToCommon: 'Isso é semelhante a uma senha comumente usada.',
        wordByItself: 'Palavras simples são fáceis de adivinhar.',
        namesByThemselves: 'Nomes ou sobrenomes são fáceis de adivinhar.',
        commonNames: 'Nomes e sobrenomes comuns são fáceis de adivinhar.',
        userInputs: 'Senha não deve haver nenhum dado pessoal ou relacionado.',
        pwned: 'Esta senha já foi exposta por uma violação de dados na Internet.',
    },
    suggestions: {
        l33t: "Evite substituições previsíveis de letras, como '@' por 'a'.",
        reverseWords: 'Evite utilizar palavras comuns escritas de "trás para frente".',
        allUppercase: 'Utilize apenas algumas letras maiúsculas, não todas.',
        capitalization: 'Utilize outras letras maiúsculas, além do que primeira.',
        dates: 'Evite datas e anos associados a você',
        recentYears: 'Evite anos recentes',
        associatedYears: 'Evite anos associados a você.',
        sequences: 'Evite sequências comuns de caracteres',
        repeated: 'Evite repetir sequências de caracteres e palavras.',
        longerKeyboardPattern: 'Use padrões de teclado mais longos e altere a direção de digitação várias vezes.',
        anotherWord: 'Adicione mais palavras menos comuns.',
        useWords: 'Use várias palavras, mas evite frases comuns.',
        noNeed: 'Você pode criar senhas fortes sem usar símbolos, números ou letras maiúsculas.',
        pwned: 'Se você usar esta senha em outro lugar, você deve alterá-la.',
    },
    timeEstimation: {
        ltSecond: 'menos de um segundo',
        second: '{base} segundo',
        seconds: '{base} segundos',
        minute: '{base} minuto',
        minutes: '{base} minutos',
        hour: '{base} hora',
        hours: '{base} horas',
        day: '{base} dia',
        days: '{base} dias',
        month: '{base} mês',
        months: '{base} meses',
        year: '{base} ano',
        years: '{base} anos',
        centuries: 'séculos',
    },
};
//# sourceMappingURL=translations.js.map